// Auto-generated version info - DO NOT EDIT MANUALLY
// This file is updated during builds.

export const APP_VERSION = process.env.REACT_APP_VERSION || '1.19.1';
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '2026-10-26T16:12:30.732Z';
export const COMMIT_HASH = process.env.REACT_APP_COMMIT_HASH || 'dev';

// Export for global access
if (typeof window !== 'undefined') {
  (window as any).__APP_VERSION = APP_VERSION;
  (window as any).__BUILD_DATE = BUILD_DATE;
  (window as any).__COMMIT_HASH = COMMIT_HASH;
  (window as any).__APP_BUILD_DATE = BUILD_DATE;
}
